import React from 'react';
import './StockStatus.css';

const StockStatus = ({ stock, minimum, unit = 'M' }) => {
  const getStockStatusClass = (stock, minimum) => {
    if (stock <= minimum) {
      return 'stock-critical';
    }
    if (stock <= minimum * 1.3) { // 30% above minimum
      return 'stock-warning';
    }
    return 'stock-good';
  };

  const statusClass = getStockStatusClass(stock, minimum);

  return (
    <div className={`stock-status ${statusClass}`}>
      <div className="stock-label">Estoque</div>
      <div className="stock-value">{stock} {unit}</div>
      <div className="stock-min">Mín: {minimum} {unit}</div>
    </div>
  );
};

export default StockStatus;
